'use client';

import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { AuthProvider } from '@/context/AuthContext';
import { CompareProvider } from '@/context/CompareContext';
import { LanguageProvider } from '@/context/LanguageContext';
import { LangPrefixProvider } from '@/context/LangPrefixContext';
import { SPARouterProvider } from '@/context/SPARouterContext';

const ScrollToTopButton = dynamic(() => import('@/components/common/ScrollToTop'), {
  ssr: false,
  loading: () => null,
});

const RouteScrollToTop = dynamic(
  () => import('@/components/common/ScrollToTop').then((mod) => mod.RouteScrollToTop),
  { ssr: false, loading: () => null }
);

const RouteProgress = dynamic(() => import('@/components/common/RouteProgress'), {
  ssr: false,
  loading: () => null,
});

const RegisterSW = dynamic(() => import('@/components/pwa/RegisterSW'), {
  ssr: false,
  loading: () => null,
});

const PWAInstallPrompt = dynamic(() => import('@/components/pwa/PWAInstallPrompt'), {
  ssr: false,
  loading: () => null,
});

const PWAUpdateToast = dynamic(
  () => import('@/components/pwa/PWAInstallPrompt').then((mod) => mod.PWAUpdateToast),
  { ssr: false, loading: () => null }
);

export default function ClientProviders({ lang, children }) {
  // Remove skeleton once React app is ready
  useEffect(() => {
    const el = document.getElementById('shell-skeleton');
    if (el) el.remove();
  }, []);

  return (
    <SPARouterProvider lang={lang}>
      <LanguageProvider>
        <AuthProvider>
          <CompareProvider>
            <LangPrefixProvider lang={lang}>
              <div className="App">
                <RouteProgress />
                <RouteScrollToTop />
                <ScrollToTopButton />
                <RegisterSW />
                <PWAInstallPrompt />
                <PWAUpdateToast />
                {children}
              </div>
            </LangPrefixProvider>
          </CompareProvider>
        </AuthProvider>
      </LanguageProvider>
    </SPARouterProvider>
  );
}
